import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import laundry from "../../../Assets/Projects/website/Laundry.png";
import laundry2 from "../../../Assets/Projects/website/Laundry2.png";
import laundry3 from "../../../Assets/Projects/website/Laundry3.png";
import laundry4 from "../../../Assets/Projects/website/Laundry4.png";
import laundry5 from "../../../Assets/Projects/website/Laundry5.png";
import laundry6 from "../../../Assets/Projects/website/Laundry6.png";
import laundry7 from "../../../Assets/Projects/website/Laundry7.png";
import laundry8 from "../../../Assets/Projects/website/Laundry8.png";
import laundry9 from "../../../Assets/Projects/website/Laundry9.png";
import laundry10 from "../../../Assets/Projects/website/Laundry10.png";
import laundry11 from "../../../Assets/Projects/website/Laundry11.png";

function RumahLaundry() {
  return (
    <ProjectDetailCard
      title="Rumah Laundry Management System"
      image={laundry2}
      screenshots={[laundry11, laundry3, laundry4]}
      description="
      Rumah Laundry Management System is a web-based application developed to streamline laundry business operations through digital management. The system enables administrators to manage customer information, laundry orders, service packages, transaction records, and order status in a centralized platform. It also provides reporting features and an intuitive user interface to improve operational efficiency, reduce manual work, and enhance customer service.
      "
      technologies={[
        "PHP",
        "CodeIgniter 4",
        "MySQL",
        "Bootstrap 5",
        "JavaScript",
        "HTML5",
        "CSS3",
        "Git",
        "Responsive Design",
        "CRUD System",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={laundry5} alt="gallery1" />
          <img src={laundry6} alt="gallery2" />
          <img src={laundry7} alt="gallery3" />
          <img src={laundry8} alt="gallery3" />
          <img src={laundry9} alt="gallery3" />
          <img src={laundry10} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default RumahLaundry;
